import { graphql } from "../__generated__/gql";

export const GET_HS12_PRODUCTS_QUERY = graphql(`
  query GetHS12Products($servicesClass: ServicesClass) {
    section: productHs12(productLevel: 1, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    twoDigit: productHs12(productLevel: 2, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    fourDigit: productHs12(productLevel: 4, servicesClass: $servicesClass) {
      ...ProductMetadata
    }

    sixDigit: productHs12(productLevel: 6, servicesClass: $servicesClass) {
      ...ProductMetadata
    }
  }

`);

export default GET_HS12_PRODUCTS_QUERY;
